<template>
    <div>
        <b-modal
            id="documentModal"
            ref="documentModal"
            :lazy="true"
            @shown="shown"
            title-tag="h2"
            :scrollable="true"
            title="Documents"
        >
            <form class="form-horizontal bundle">
                <div
                    style="overflow-wrap: break-word;"
                    :key="document.id"
                    v-for="document in documents"
                >
                    <a target="“_blank”" :href="getURI(document)">{{
                        getTitle(document)
                    }}</a>
                    <hr class="mb-0" style="margin-bottom: 14px !important;" />
                </div>
            </form>

            <div slot="modal-footer" class="w-100">
                <b-button
                    v-if="!loading"
                    @click="$refs.documentModal.hide('cancel')"
                    class="float-left"
                    variant="secondary"
                    >Cancel</b-button
                >
                <img v-else class="float-right" src="assets/ajax-loader.gif" />
            </div>
        </b-modal>
    </div>
</template>
<script>
import { uniqBy } from "lodash";

export default {
    name: "Document",
    data() {
        return {
            loading: false,
            documents: [],
            data: {}
        };
    },
    mounted() {},
    methods: {
        open(params) {
            let self = this;
            this.data = params;
            self.$refs.documentModal.show();
        },
        shown() {
            Promise.all([this.getDocuments(), this.getTreatmentSummary()]).then(
                () => {
                    this.loading = false;
                }
            );
        },
        getDocuments() {
            this.loading = true;
            return this.$http
                .get(
                    process.env.BARRACUDA +
                        "schedule/treatment-documents/" +
                        this.data.id
                )
                .then(response => {
                    if (response.data.response.resources) {
                        this.documents = uniqBy(
                            response.data.response.resources.data,
                            "name"
                        );
                    }
                    return this.documents;
                });
        },
        getURI(object) {
            let uri = "";

            switch (object.module) {
                case "attachment":
                case "treatmentSummary":
                    uri = object.uri;
                    break;
                default:
                    uri = process.env.CI_APPS + object.uri;
                    break;
            }

            return uri;
        },
        getTitle(object) {
            let title = "";

            switch (object.module) {
                case "attachment":
                case "treatmentSummary":
                    title = object.name;
                    break;
                default: {
                    let date = this._fromDateCarbon(object.date).setZone(
                        this._timeZone
                    );
                    title =
                        object.name +
                        " (" +
                        date.toFormat(this._dateFormat) +
                        ")";
                    break;
                }
            }

            return title;
        },
        async getTreatmentSummary() {
            let self = this;
            return await this.$http
                .get(
                    process.env.BARRAMUNDI +
                        "schedule/treatment-summary/" +
                        self.data.id
                )
                .then(response => {
                    if (response.data.response.message.code === 200) {
                        let treatmentSummary = {
                            name: "Treatment Summary",
                            uri: response.data.response.resources.path,
                            module: "treatmentSummary"
                        };
                        self.documents.push(treatmentSummary);
                    }
                });
        }
    }
};
</script>
